const getStatusPinState = (pinned, status) => {
  if (!status) {
    return { pinned: [], protected: [] };
  }

  if (Array.isArray(pinned)) {
    return status === "open" ? { pinned, protected: [] } : { pinned: [], protected: [] };
  }

  if (pinned && typeof pinned === "object") {
    const value = pinned[status];
    if (Array.isArray(value)) {
      return { pinned: value, protected: [] };
    }

    if (value && typeof value === "object") {
      return {
        pinned: Array.isArray(value.pinned) ? value.pinned : [],
        protected: Array.isArray(value.protected) ? value.protected : [],
      };
    }
  }

  return { pinned: [], protected: [] };
};

export const getPinnedIdsForStatus = (pinned, status) => {
  return getStatusPinState(pinned, status).pinned;
};

export const isPinnedForUser = (pinned, status, userId) => {
  const list = getPinnedIdsForStatus(pinned, status);
  return list.some((id) => String(id) === String(userId));
};

export const getPinModeForUser = (pinned, status, userId) => {
  const state = getStatusPinState(pinned, status);

  if (state.pinned.some((id) => String(id) === String(userId))) {
    return "pinned";
  }

  if (state.protected.some((id) => String(id) === String(userId))) {
    return "protected";
  }

  return "none";
};
